/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deals_Lost_ReasonInputs */

const cs_deals_lost_reason = /** @type {(inputs: Deals_Lost_ReasonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Důvod prohry`)
};

const en_deals_lost_reason = /** @type {(inputs: Deals_Lost_ReasonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lost reason`)
};

/**
* | output |
* | --- |
* | "Lost reason" |
*
* @param {Deals_Lost_ReasonInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const deals_lost_reason = /** @type {((inputs?: Deals_Lost_ReasonInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deals_Lost_ReasonInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deals_lost_reason(inputs)
	return cs_deals_lost_reason(inputs)
});